import { defineMessages } from 'react-intl';

export const AuthPage = defineMessages({
  missingApiKey: {
    id: 'app.AuthPage.missingKey',
    defaultMessage: 'API klíč chybí. Aplikace je dostupná pouze s validním API klíčem',
  },
  validationFailed: {
    id: 'app.AuthPage.validationFailed',
    defaultMessage: 'Validace API klíče selhala',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
  headerContent: {
    id: 'app.AuthPage.headerContent',
    defaultMessage: 'Ověření API klíče lokace',
  },
  loadingMessage: {
    id: 'app.AuthPage.loadingMessage',
    defaultMessage: 'Ověřuji API klíč lokace ...',
  },
  offlineMessage: {
    id: 'app.AuthPage.offlineMessage',
    defaultMessage: 'POZOR JSTE OFFLINE, nemůžeme ověřit platnost API klíče.',
  },
  apiKeyInfo: {
    id: 'app.AuthPage.apiKeyInfo',
    defaultMessage: 'Hodnotu API klíče, obdržíte od vaší kontaktní osoby.',
  },
  requiredValue: {
    id: 'app.AuthPage.requiredValue',
    defaultMessage: 'Vyplnění této hodnoty je povinné',
  },
  apiKey: {
    id: 'app.AuthPage.apiKey',
    defaultMessage: 'API klíč',
  },
  apiKeyPlaceholder: {
    id: 'app.AuthPage.apiKeyPlaceholder',
    defaultMessage: 'Sem vložte API klíč lokace',
  },
  email: {
    id: 'app.AuthPage.email',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'app.AuthPage.emailPlaceholder',
    defaultMessage: 'Sem zadejte váš pracovní email',
  },
});
